<template>
  <section class="p-2">
    <v-card class="">
      <v-card-title class="d-flex justify-space-between p-0 m-0">
        <div class="ps-2 subtitle-1">Transction Hold</div>
        <div>
          <bread-crumb :bread-crumbs="['Hold Transactions']" />
        </div>
      </v-card-title>
      <v-divider class="p-0 m-0 primary--text"></v-divider>
      <div class="">
        <v-card-text class="mt-3">
          <v-row>
            <v-col cols="12" md="3">
              <v-text-field
                v-model="from_date"
                label="From Date"
                type="date"
                dense
                outlined
                class="rounded"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                v-model="to_date"
                type="date"
                label="To Date"
                dense
                outlined
                class="rounded"
              >
              </v-text-field>
            </v-col>
            <v-btn
              depressed
              @click="getDataByDate()"
              class="mr-2 mt-1"
              color="primary"
              small
              >Get Results
            </v-btn>
            <v-btn
              depressed
              @click="downloadExcelsheet"
              class="mt-1 ms-1"
              color="primary"
              small
              ><v-icon small>mdi-file-excel-outline</v-icon>Export
            </v-btn>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Type here to filter values."
              hide-details
              dense
              single-line
              clearable
              class="mt-1"
            ></v-text-field
          ></v-row>
        </v-card-text>

        <v-data-table fixed-header  height="55vh" :headers="headers" :items="holdTxnlist" class="">
          <template v-slot:item.actions="{ item }">
            <v-btn
              depressed
              outlined
              small
              color="green"
              class="text-capitalize"
              @click="openPopup(item)"
              >Release<v-icon x-small class="ms-2"
                >mdi-checkbox-marked-circle-outline</v-icon
              ></v-btn
            >
          </template>
          <template v-slot:item.txn_status="{ item }">
            <v-chip rounded small color="primary" block outlined>
              {{ item.txn_status }}
            </v-chip>
          </template>
          <template v-slot:item.payment_id="{ item }">
            <a class="border-d" @click="viewTxn(item)">{{ item.payment_id }}</a>
          </template>
          <template v-slot:item.bank_receipt="{ item }">
            <v-img
              v-if="item.bank_receipt"
              class="ml-1"
              max-height="40"
              max-width="50"
              :src="item.bank_receipt"
              @click="handleImageViewer(item.bank_receipt, '')"
            />
          </template>
        </v-data-table>
      </div>
      <v-dialog persistent v-model="showPopup" max-width="500px">
        <v-card>
          <v-toolbar class="ma-0 pa-0" color="secondary" dark flat dense>
            <span>Release Transaction</span>
            <!-- <v-spacer></v-spacer> -->
            <v-spacer></v-spacer>
            <v-icon small @click="closePopup">mdi-close</v-icon>
          </v-toolbar>
          <v-form>
            <!-- <v-divider class="ma-0 pa-0"></v-divider> -->
            <v-card-text class="mt-2">
              <v-form v-model="valid" ref="releaseForm">
                <v-row>
                  <v-col cols="12" sm="12" md="12"
                    ><label class="my-0 labelFontsize required"> Status </label>
                    <v-autocomplete
                      class="rounded"
                      dense
                      outlined
                      placeholder="Status"
                      :items="status_items"
                      :rules="validations.statusRules"
                      v-model="selectedStatus"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="12" md="12"
                    ><label class="my-0 labelFontsize required"> Release </label>
                    <v-autocomplete
                      class="rounded"
                      dense
                      outlined
                      placeholder="Release"
                      :items="release_items"
                      :rules="validations.releaseRules"
                      v-model="selectedReleaseItem"
                    ></v-autocomplete>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                    class="my-0"
                    v-if="selectedReleaseItem === 'Others'"
                    ><label class="my-0 labelFontsize required">Remarks</label>
                    <v-text-field
                      class="rounded"
                      dense
                      outlined
                      :rules="validations.remarksRules"
                      placeholder="Remarks"
                      v-model="remarks"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>
          </v-form>

          <v-card-actions class="justify-end">
            <v-btn
              depressed
              outlined
              class="text-capitalize primary--text"
              small
              @click="updateTxnStatus()"
              >Submit</v-btn
            >
            <!-- <v-btn
              depressed
              color="error"
              class="text-capitalize"
              outlined
              small
              @click="updateTxnStatus('Cancel')"
              >Reject</v-btn
            >
            <v-btn
              depressed
              color="warning"
              class="text-capitalize"
              outlined
              small
              @click="updateTxnStatus('Hold')"
              >Hold</v-btn
            >
            <v-btn
              depressed
              color="primary"
              class="text-capitalize"
              small
              @click="updateTxnStatus('Success')"
              >Release</v-btn
            > -->
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>
    <image-viewer
      :showDialog="isImageViewer"
      :picture="{
        PicHeight: '350',
        PicWidth: 600,
        Pic: imageViewerUrl,
      }"
      @closeImageViewer="handleCloseImageViewer"
    ></image-viewer>
    <OverlayPageVue :showOverlay="loader" />
  </section>
</template>

<script>
import BreadCrumb from "@/components/navigations/BreadCrumb.vue";
import imageViewer from "@/components/tools/imageViewer.vue";
import alerts from "@/mixins/alerts";
import OverlayPageVue from "../../../utils/OverlayPage.vue";
import PaymentService from "@/services/PaymentService/paymentService.js";
import CommonService from "@/services/CommonService/commonService.js";
export default {
  name: "Hold Transactions",
  mixins: [alerts],
  data() {
    return {
      showPopup: false,
      imageViewerUrl: null,
      isImageViewer: false,
      showRemarksField: false,
      selectedReleaseItem: null,
      remarks: "",
      valid: false,
      selectedTxn: null,
      from_date: new Date().toISOString().substr(0, 10),
      to_date: new Date().toISOString().substr(0, 10),
      search: "",
      selectedStatus: "",
      headers: [
        { text: "Transcation number", value: "payment_id", sortable: false },
        // {
        //   text: "Partner Transcation number",
        //   value: "partner_pinnumber",
        //   sortable: false,
        // },
        { text: "Sender Name", value: "sender_name", align: "start" },
        { text: "Transcation date", value: "txn_date", sortable: false },
        { text: "Transcation status", value: "txn_status", sortable: false },
        {
          text: "Beneficiary country",
          value: "receiver_country",
          sortable: false,
        },
        { text: "Beneficiary name", value: "receiver_name", sortable: false },
        {
          text: "Receiving agent",
          value: "receiving_partner",
          sortable: false,
        },
        { text: "Payment mode", value: "payment_mode", sortable: false },
        { text: "Receiving amount", value: "amount", sortable: false },
        { text: "Remarks", value: "remarks", sortable: false },
        { text: "Bank Advice", value: "bank_receipt", sortable: false },
        {
          text: "Actions",
          sortable: false,
          value: "actions",
        },
      ],
      holdTxnlist: [],
      release_items: [],
      status_items: ["Processing", "Paid", "Cancel", "Hold", "Success"],
      validations: {
        releaseRules: [(v) => !!v || "Required"],
        remarksRules: [(v) => !!v || "Rquired"],
        statusRules: [(v) => !!v || "Rquired"],
      },
      loader: false,
    };
  },
  components: {
    BreadCrumb,
    imageViewer,
    OverlayPageVue,
  },
  mounted() {
    // const istodaytnx = this.$route?.query?.istodaytnx;
    // if (istodaytnx) {
    //   this.getHoldTransactions(istodaytnx);
    // } else {
    //   this.getHoldTransactions("false");
    // }
    this.getReleaseRemarks();
  },
  watch: {},
  methods: {
    async downloadExcelsheet() {
      if (this.holdTxnlist) {
        this.exportToExcel(this.headers, this.holdTxnlist, "holdTxn_list");
      }
    },
    viewTxn(item) {
      console.log(item, "DD");
      this.$router.push({
        name: "Hold Details",
        query: {
          id: item.id,
          login_id: item.login_id,
          from: "hold",
          payment_id: item.payment_id,
        },
      });
    },
    handleCloseImageViewer() {
      this.isImageViewer = !this.isImageViewer;
      this.imageViewerUrl = "";
    },
    handleImageViewer(url, val) {
      if (val === "showImage") {
        this.isImageViewer = !this.isImageViewer;
        this.imageViewerUrl = url;
      } else {
        this.isImageViewer = !this.isImageViewer;
        this.imageViewerUrl = url;
      }
    },
    Imageview(file) {
      const imageurl = URL.createObjectURL(file);
      this.suspectFileUrl = imageurl;
    },

    async getReleaseRemarks() {
      this.loader = true;
      try {
        const responseData = await CommonService.getRemarks();
        if (responseData && responseData.data.status_code === 200) {
          this.release_items = responseData.data.data.map((i) => i.value);
          this.loader = false;
        }
        // else if (responseData.data.status_code === 401) {
        //   this.returnNewToken();
        //   this.getReleaseRemarks();
        // }
        else {
          this.showAlertError(`Failed: ${responseData.data.message}`);
          this.loader = false;
        }
        console.log("Funds", responseData);
      } catch (e) {
        console.error(e);
        this.showAlertError("Something went wrong please try again later.");
        this.loader = false;
      }
    },
    async updateTxnStatus() {
      const validate = this.$refs.releaseForm.validate();
      const remarks =
        this.selectedReleaseItem === "Others" ? this.remarks : this.selectedReleaseItem;
      if (validate) {
        this.loader = true;
        try {
          const responseData = await PaymentService.updateTxn(
            this.selectedTxn.id,
            this.selectedTxn.customer_id,
            this.selectedStatus,
            remarks
          );
          if (responseData && responseData.data.status_code === 200) {
            const istodaytnx = this.$route?.query?.istodaytnx;
            if (istodaytnx) {
              this.getHoldTransactions(istodaytnx);
            } else {
              this.getHoldTransactions("false");
            }
            this.loader = false;
            this.$refs.releaseForm.reset();
            this.showPopup = false;
            this.showAlertSuccess(responseData.data.message);
          }
          // else if (responseData.data.status_code === 401) {
          //   this.loader = false;
          //   this.returnNewToken();
          //   this.updateTxnStatus();
          // }
          else {
            this.loader = false;
            this.showAlertError(`Failed: ${responseData.data.message}`);
          }
        } catch (e) {
          console.error(e);
          this.showAlertError("Something went wrong please try again later.");
          this.loader = false;
        }
      }
    },

    async getDataByDate() {
      this.loader = true;
      try {
        const response = await PaymentService.getHoldTxnsByDate(
          this.from_date,
          this.to_date
        );
        if (response.data.status_code === 200) {
          this.holdTxnlist = response.data.data.reverse();
          console.log("userList", this.holdTxnlist);
          this.loader = false;
        } else {
          this.holdTxnlist == [];
          this.loader = false;
        }
      } catch (error) {
        this.holdTxnlist = [];
        this.loader = false;
      }
    },

    async getHoldTransactions(isTodaytxn) {
      this.loader = true;
      try {
        const responseData = await PaymentService.getHoldTxnDetails(isTodaytxn);
        this.loader = false;
        if (responseData && responseData.data.status_code === 200) {
          this.holdTxnlist = responseData.data.data.reverse();
        }
        // else if (responseData.data.status_code === 401) {
        //   this.returnNewToken();
        //   this.getHoldTransactions(false);
        // }
        else {
          this.showAlertError(`Failed: ${responseData.data.message}`);
        }
        console.log("getdata", responseData.data.status_code);
      } catch (e) {
        console.error(e);
        this.showAlertError("Something went wrong please try again later.");
        this.loader = false;
      }
    },
    openPopup(item) {
      console.log(item);
      this.selectedTxn = item;
      this.selectedReleaseItem = null;
      this.remarks = item.remarks;
      this.showPopup = true;
    },
    closePopup() {
      // Close the popup
      this.showPopup = false;
      this.selectedReleaseItem = null;
      this.remarks = "";
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/global.scss";

.required:after {
  content: " *";
  color: red;
}
</style>
